import PlannerProfileCard from './PlannerProfileCard';
import XButton from '../common/XButton';
import { optionCardClasses } from './preliminaryLifecareClasses';

const titleWrapClasses = 'min-h-[3.5rem] flex items-center justify-center';

const titleClasses = 'text-xl font-bold text-content m-0';

const subtitleBlockClasses = 'mt-1 mb-6';

const subtitleLineClasses = 'text-base text-subtle m-0 whitespace-nowrap';

const subtitleValueClasses = 'font-bold text-content';

const actionsClasses = 'mt-auto pt-6 w-full flex justify-center';

const CertifiedPlannerOptionCard = ({ planner, costLabel, isSubmitting, onConfirm }) => (
    <div className={optionCardClasses}>
        <div className={titleWrapClasses}>
            <h3 className={titleClasses}>Request Preliminary Life Care Plan</h3>
        </div>
        <div className={subtitleBlockClasses}>
            <p className={subtitleLineClasses}>From our planner</p>
            <p className={subtitleLineClasses}>
                Cost: <span className={subtitleValueClasses}>{costLabel}</span>
            </p>
        </div>
        <PlannerProfileCard planner={planner} />
        <div className={actionsClasses}>
            <XButton onClick={onConfirm} loading={isSubmitting} loadingText="Requesting...">
                Request Preliminary Life Care Plan
            </XButton>
        </div>
    </div>
);

export default CertifiedPlannerOptionCard;
